 // src/services/OfflineService.js
    import { openDB } from 'idb';
    import api from '../api/index.js'; // Importamos nuestra instancia de Axios

    const DB_NAME = 'points-beer-pos-db';
    const STORE_NAME = 'pending-sales';
    const DB_VERSION = 1;

    // Inicializa la base de datos IndexedDB
    const initDB = async () => {
      return openDB(DB_NAME, DB_VERSION, {
        upgrade(db) {
          if (!db.objectStoreNames.contains(STORE_NAME)) {
            db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
          }
        },
      });
    };

    // Función para añadir una venta a la cola
    export const addSaleToOfflineQueue = async (salePayload) => {
      const db = await initDB();
      await db.add(STORE_NAME, { payload: salePayload, timestamp: new Date().toISOString() });
      console.log('Venta guardada en la cola offline.');
    };

    // Función para sincronizar las ventas pendientes
    export const syncPendingSales = async () => {
      const db = await initDB();
      const pendingSales = await db.getAll(STORE_NAME);

      if (pendingSales.length === 0) {
        console.log('No hay ventas pendientes para sincronizar.');
        return { success: true, synced: 0 };
      }

      console.log(`Iniciando sincronización de ${pendingSales.length} ventas pendientes...`);
      let successfulSyncs = 0;

      for (const sale of pendingSales) {
        try {
          // Intentamos enviar el payload de la venta al backend
          await api.post('/sales', sale.payload);
          // Si tiene éxito, la eliminamos de la cola de IndexedDB
          await db.delete(STORE_NAME, sale.id);
          successfulSyncs++;
          console.log(`Venta con ID local ${sale.id} sincronizada exitosamente.`);
        } catch (error) {
          console.error(`Error al sincronizar venta con ID local ${sale.id}:`, error.response?.data || error.message);
          // La venta permanece en la cola para el próximo intento.
          // Podríamos añadir lógica para no reintentar ventas con errores 4xx (datos inválidos).
        }
      }

      console.log(`Sincronización completada. ${successfulSyncs} de ${pendingSales.length} ventas sincronizadas.`);
      return { success: successfulSyncs > 0, synced: successfulSyncs, total: pendingSales.length };
    };